import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useCreateListingContext } from '../../components/create-listing/CreateListingContext';
import { CreateListingPortalCard } from '../../components/create-listing-portal/CreateListingPortalCard';
import { PageHeader } from '../../components/page-header/PageHeader';
import { RoutePath } from '../../router/Routes';
import { TableLayout } from '../layouts/table-layout/TableLayout';

import './CreateListingPortalView.scss';

export const CreateListingPortalView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { reset } = useCreateListingContext();

    useEffect(() => {
        reset();
    }, []);
    return (
        <>
            <PageHeader pageTitle={t('application.createListingPortal.header')} />
            <TableLayout>
                <div className="create-listing-portal-container">
                    <CreateListingPortalCard
                        heading={t('application.createListingPortal.single.heading')}
                        description={t('application.createListingPortal.single.description')}
                        image="/assets/lib-ui-primitive/images/ListingDraft-NeutralV2.svg"
                        buttonLabel={t('application.createListingPortal.single.button')}
                        buttonOnClick={() => {
                            navigate(RoutePath.CREATE_LISTING_WIZARD, {
                                state: {
                                    goBackLink: RoutePath.CREATE_LISTING_PORTAL,
                                    goBackText: t('application.createListingPortal.header'),
                                },
                            });
                        }}
                    />
                    <CreateListingPortalCard
                        heading={t('application.createListingPortal.bulk.heading')}
                        description={t('application.createListingPortal.bulk.description')}
                        image="/assets/lib-ui-primitive/images/ListingDraft-NeutralMulti.svg"
                        buttonLabel={t('application.createListingPortal.bulk.button')}
                        buttonOnClick={() => {
                            navigate(RoutePath.CREATE_BULK_LISTING_WIZARD);
                        }}
                    />
                </div>
            </TableLayout>
        </>
    );
};
